"use strict";

require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.PhonePLRule = function () {
  $.validator.addMethod("phonePL", function (value, element) {
    var rules = /^[+0-9]{9,15}$/;
    var isCorrect = rules.test(value);
    if (!isCorrect) {
      $(element).parent().find('.tooltip-label').hide();
    }
    return isCorrect;
  }, $.validator.messages.phonePL);
}();